export default __webpack_public_path__ + "static/activities_image_six-0d614a2eddd6e8a24dd60499e674b1b5.png";